import React from 'react';
import { Button, Typography, Box } from '@mui/material';
import { changeLanguage as changeLanguageFunction } from '../../redux/slices/languageSlice';
import { useDispatch, useSelector } from 'react-redux';

function TopBar() {
  const { selectedLanguage } = useSelector(state => state.language);
  const dispatch = useDispatch();
  const changeLanguage = (lang) => dispatch(changeLanguageFunction(lang));

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        backgroundColor: '#e6e6e6',
        padding: { xs: '4px 8px', md: '5.6px 11px' },
        borderRadius: '4px',
        flexWrap: 'wrap',
      }}
    >
      <Typography
        variant="body2"
        sx={{ marginRight: '8px', fontWeight: 'bold', fontSize: { xs: '0.75rem', md: '1rem' } }}
      >
        महाराष्ट्र शासन
      </Typography>
      <Typography
        variant="body2"
        sx={{ marginRight: 'auto', fontSize: { xs: '0.75rem', md: '1rem' } }}
      >
        Government of Maharashtra
      </Typography>

      {['en', 'mr', 'hi', 'gu'].map((lang, index) => (
        <React.Fragment key={lang}>
          <Button
            variant={selectedLanguage === lang ? 'contained' : 'text'}
            color="primary"
            sx={{
              backgroundColor: selectedLanguage === lang ? '#002855' : 'transparent',
              color: selectedLanguage === lang ? '#ffffff' : 'inherit',
              textTransform: 'none',
              fontWeight: selectedLanguage === lang ? 'bold' : 'normal',
              padding: { xs: '2px 4px', md: '2.8px 5.6px' },
              margin: '0 4px',
              fontSize: '0.875rem'
            }}
            onClick={() => changeLanguage(lang)}
          >
            {lang === 'en' ? 'English' : lang === 'mr' ? 'मराठी' : lang === 'gu' ? 'ગુજરાતી' : 'हिंदी'}
          </Button>
          {index < 3 && (
            <Typography variant="body2" sx={{ margin: '0 4px' }}>|</Typography>
          )}
        </React.Fragment>
      ))}
    </Box>
  );
}

export default TopBar;
